/**
 * Převod čísla na měnu (CZK).
 */
export function toCurrencyString(value, currency = 'CZK') {
    const isWhole = Number.isInteger(value);

    return new Intl.NumberFormat('cs-CZ', {
        style: 'currency',
        currency,
        minimumFractionDigits: isWhole ? 0 : 2,
        maximumFractionDigits: isWhole ? 0 : 2,
    }).format(value);
}

/**
 * Formát čísla s tisícovými oddělovači.
 */
export function formatNumber(value) {
    return new Intl.NumberFormat('cs-CZ').format(value);
}
